function btnControl(btnId) {
  let powerIds = localStorage.getItem("powerIds")
  if (!powerIds.includes(btnId)) {
    console.log(`按钮 ${btnId} 被屏蔽 ~ ~ ~`);
  }
  return powerIds.includes(btnId)
}

module.exports = btnControl


// WEBPACK FOOTER //
// ./src/utils/btnControll.js